/**
 * Maps the related-categories api response to the data the card needs.
 * Eligibility is decided server-side: the api returns no category for
 * ineligible projects, in which case this returns null and no card renders.
 * variant is kept null when absent so it can't be confused with control (0).
 */
export const getRelatedCategoryCardData = (apiResponse) => {
	const category = apiResponse && apiResponse.category;
	if (!category) {
		return null;
	}
	const location = apiResponse.location;
	return {
		categoryId: category.id,
		categoryName: category.name,
		categorySlug: category.slug,
		location:
			location && location.id
				? { id: location.id, name: location.name, type: location.type }
				: null,
		variant: apiResponse.variant ?? null,
	};
};

/**
 * Renders the related-category card from the #related-category-card-template
 * Handlebars template embedded in seller-list.twig. All values are escaped by
 * Handlebars, so label strings interpolating api data are safe to pass raw.
 *
 * @param {Object} cardData
 * @param {number} cardData.categoryId
 * @param {string} cardData.eyebrow
 * @param {string} cardData.timeEstimate
 * @param {string} cardData.title
 * @param {string} cardData.subtitle
 * @param {string} cardData.ctaLabel
 * @param {string} cardData.skipLabel
 * @returns {string} html, or '' when the page has no template
 */
export const buildRelatedCategoryCardHtml = (cardData) => {
	const source = document.getElementById('related-category-card-template');
	if (!source || !window.Handlebars) {
		return '';
	}
	return window.Handlebars.compile(source.innerHTML)(cardData);
};
